module.exports = __webpack_public_path__ + "media/images/flags/64/Guatemala-0ea6e5a779eaed01cdb922a1d48ab594.png";